<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import {
  Empty,
  EmptyHeader,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
} from 'next/polaris/ui/empty';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Auth from 'dashboard/api/auth';

const { t } = useI18n();
const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const message = computed(() => {
  if (isOnChatwootCloud.value) {
    return t('APP_GLOBAL.NO_ACCOUNTS.MESSAGE_CLOUD');
  }
  return t('APP_GLOBAL.NO_ACCOUNTS.MESSAGE_SELF_HOSTED');
});

const handleLogout = () => {
  Auth.logout();
};
</script>

<template>
  <div
    class="flex items-center justify-center h-full w-full bg-polaris-background text-polaris-foreground"
  >
    <Empty>
      <EmptyHeader>
        <EmptyTitle>{{ $t('APP_GLOBAL.NO_ACCOUNTS.TITLE') }}</EmptyTitle>
        <EmptyDescription>{{ message }}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <NextButton
          variant="outline"
          color="slate"
          :label="$t('APP_GLOBAL.NO_ACCOUNTS.LOGOUT')"
          @click="handleLogout"
        />
      </EmptyContent>
    </Empty>
  </div>
</template>
